import { regexPatterns } from '@utils';

export default {
  data() {
    return {
      errorsVisible: false,
    };
  },

  props: {
    rules: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    valueForErrors() {
      return this.value;
    },

    combinedErrors() {
      if (!this.rules) {
        return [];
      }

      const rules = this.rules.split('|');
      const errors = [];

      rules.forEach((rule) => {
        const ruleRegexPattern = regexPatterns[rule];

        if (rule === 'required') {
          if (!this.valueForErrors) {
            errors.push('This field is required');
          }
        } else if (!ruleRegexPattern?.regex?.test(this.valueForErrors)) {
          errors.push('This field is incorrect');
        }
      });

      return errors;
    },

    showError() {
      return (this.errorsVisible && this.combinedErrors.length) || this.error;
    },
  },

  methods: {
    makeErrorsVisible() {
      this.errorsVisible = true;
    },
  },
};
